import { selectedCompanyStorage } from '../../storage/company/selected-company.util';

export const useCompanyContextReady = (companyId: string) => {
  const company = selectedCompanyStorage(({ company }) => company);
  return company?.id === companyId;
};
